<template>
    <div class="profile__auth">
        <strong class="profile__authmsg r-strong">Вы должны войти в систему, чтобы записаться на прием</strong>
        <ul class="profile__authactions r-list h-list">
            <li class="h-list__group">
                <a href="/login"  class="profile__login r-link button">Вход</a>
            </li>
            <li class="h-list__group">
                <a href="/register" class="r-link">Регистрация</a>
            </li>
        </ul>
    </div>
</template>


<script>
    export default {
        name: 'ScheduleLogInMessage',
    }
</script>

